// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_INDUCTION_DETAIL_REQUEST,
  GET_INDUCTION_DETAIL_REQUEST_SUCCESS,
  GET_INDUCTION_DETAIL_REQUEST_ERROR,
} from "../constants";
import axios from "../../../services/api";
import { push } from "connected-react-router";

function* getInductionRequest(data) {
  try {
    const response = yield call(axios.get, `/induction-details/?id=${data.id}`);
    if (response.data.error) {
      yield put({
        type: GET_INDUCTION_DETAIL_REQUEST_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_INDUCTION_DETAIL_REQUEST_SUCCESS,
        data: { ...response.data, id: data.id },
      });

      yield put(push(`${response?.data?.data?.pages[0]?.url}`));
    }
  } catch (error) {
    yield put({
      type: GET_INDUCTION_DETAIL_REQUEST_ERROR,
      data: error,
    });
  }
}

export default function* getInductionRequestSaga() {
  yield takeLatest(GET_INDUCTION_DETAIL_REQUEST, getInductionRequest);
}
